const awsconfig = {
  aws_project_region: "ap-northeast-1",
  aws_cognito_region: "ap-northeast-1",
  aws_user_pools_id: "ap-northeast-1_3ty0LeL1u",
  aws_user_pools_web_client_id: "f9g41knimcue4j87fraluv7bk",
  oauth: {},
  aws_appsync_graphqlEndpoint: "",
  aws_appsync_region: "ap-northeast-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
};

export default awsconfig;